import { useEffect } from 'react';
import 'react-circular-progressbar/dist/styles.css';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import { Ranking } from './Ranking';
import { getRanking } from './Ranking.actions';

export const RankingRoot = () => {
  const dispatch = useAppDispatch();

  const { ranking, loading } = useAppSelector((state) => state.ranking);

  useEffect(() => {
    dispatch(getRanking());
  }, [dispatch]);

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard>
      <Ranking ranking={ranking} />
    </AnimatedDashboard>
  );
};
